import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#customer #company_id					{ width: 10rem;		}
			#customer #id							{ width: 5rem; text-align: right;	}
			#customer #payment_term_id				{ width: 11rem; 	}
			#customer #price_list_id				{ width: 11rem; 	}
			#customer #delivery_term				{ width: 4rem; 		}
			#customer #type							{ width: 4rem;		}
			#customer #nick							{ width: 18rem;		}
			#customer #name							{ width: 20rem; 	}
			#customer #email						{ width: 15rem;		}
			#customer #phone						{ width: 10rem;		}
			#customer #cpf							{ width: 10rem;		}
			#customer #cnpj							{ width: 11rem; 	}
			#customer #ie							{ width: 10rem; 	}
			#customer #ie_type						{ width: 11rem;		}
			#customer #billing_address_street		{ width: 20rem;		}
			#customer #billing_address_number		{ width: 5rem;		}
			#customer #billing_address_complement	{ width: 10rem;		}
			#customer #billing_address_district		{ width: 15rem;		}
			#customer #billing_address_state		{ width: 3.5rem;	}
			#customer #billing_address_city_id		{ width: 15rem;		}
			#customer #billing_address_zipcode		{ width: 6rem;		}
			#customer #delivery_address_street		{ width: 20rem;		}
			#customer #delivery_address_number		{ width: 5rem;		}
			#customer #delivery_address_complement	{ width: 10rem;		}
			#customer #delivery_address_district	{ width: 15rem;		}
			#customer #delivery_address_state		{ width: 3.5rem;	}
			#customer #delivery_address_city_id		{ width: 15rem;		}
			#customer #delivery_address_zipcode		{ width: 6rem;		}
			#customer fieldset						{ display: inline-block; }
			#customer .addr-hint					{ min-height: 2rem; align-items: center; }
			#customer .cep-hint					{ font-size: 0.85em; color: var(--muted, #666); }
		</style>
		<form id="customer" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="billing_cities">
			</datalist>
			<datalist id="delivery_cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do cliente">Cliente
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jurídica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Condição de pagamento padrão">Condição de Pagto
					<input id="payment_term_id" type="text" list="payment_terms">
				</label>
				<label title="Lista de preços vinculada ao cliente">Lista de Preços
					<input id="price_list_id" type="text" list="price_lists">
				</label>
				<label title="Prazo de entrega em dias">Prazo<sup>*</sup>
					<input id="delivery_term" type="text" placeholder="0" required>
				</label>
				<label title="Cliente é consumidor final?">Consumidor
					<input id="is_end_consumer" type="checkbox" checked>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome curto do cliente">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
				<label title="Nome ou razão social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="Número do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="Número do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="Número da Inscrição Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscrição Estadual">Tipo IE
					<input id="ie_type" type="text" list="ie_types">
				</label>
			</div>
			<div class="fsb">
				<fieldset>
					<legend>Endereço de Faturamento</legend>
					<div class="fsb addr-hint">
						<label title="Usar o mesmo endereço de entrega para faturamento" style="display:flex;align-items:center;gap:0.5rem;">
							<input id="same_billing_delivery" type="checkbox"> Mesmo endereço de entrega
						</label>
					</div>
					<input type="hidden" id="billing_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="billing_address_street" type="text">
						</label>
						<label title="Número">Número
							<input id="billing_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="billing_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="billing_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="billing_address_state" type="text" list="states">
						</label>
						<label title="Município (ou digite CEP antes para preencher automaticamente)">Município
							<input id="billing_address_city_id" type="text" list="billing_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="billing_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
				<fieldset>
					<legend>Endereço de Entrega</legend>
					<div class="fsb addr-hint">
						<span class="cep-hint" title="Consulta ViaCEP (base dos Correios)">Digite o CEP e saia do campo para preencher automaticamente</span>
					</div>
					<input type="hidden" id="delivery_address_id">
					<div class="fsb">
						<label title="Nome da rua ou avenida">Logradouro
							<input id="delivery_address_street" type="text">
						</label>
						<label title="Número">Número
							<input id="delivery_address_number" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Complemento">Complemento
							<input id="delivery_address_complement" type="text">
						</label>
						<label title="Bairro">Bairro
							<input id="delivery_address_district" type="text">
						</label>
					</div>
					<div class="fsb">
						<label title="Unidade Federativa">UF
							<input id="delivery_address_state" type="text" list="states">
						</label>
						<label title="Município (ou digite CEP antes para preencher automaticamente)">Município
							<input id="delivery_address_city_id" type="text" list="delivery_cities">
						</label>
						<label title="CEP: digite e saia do campo para buscar nos Correios">CEP
							<input id="delivery_address_zipcode" type="text" placeholder="00000-000">
						</label>
					</div>
				</fieldset>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#customer',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const sel = formset.form.selector;
			const typeEl = document.querySelector(`${sel} #type`);
			const cnpjEl = document.querySelector(`${sel} #cnpj`);
			const cnpjLabel = cnpjEl?.closest('label');
			const toggleCnpjForTypeL = () => {
				if (!typeEl || !cnpjEl) return;
				const isLocal = typeEl.value?.trim() === 'L';
				cnpjEl.placeholder = isLocal ? 'Cód. GSNet (ex.: 1233)' : '00.000.000/0000-00';
				cnpjEl.title = isLocal ? 'Código GSNet (alfanumérico, até 10 caracteres)' : 'Número do CNPJ';
				if (cnpjLabel) cnpjLabel.title = cnpjEl.title;
			};
			const ieTypeEl = document.querySelector(`${sel} #ie_type`);
			const toggleIeTypeRequired = () => {
				const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
				if (ieTypeEl) ieTypeEl.required = !isLocal;
			};
			const ptEl = document.querySelector(`${sel} #payment_term_id`);
			const togglePaymentTermForTypeL = () => {
				if (!ptEl) return;
				const isLocal = typeEl?.value?.trim().toUpperCase() === 'L' || typeEl?.value?.trim().toUpperCase() === 'LOCAL';
				if (isLocal) {
					ptEl.value = '';
					ptEl.setAttribute('readonly', '');
				} else {
					ptEl.removeAttribute('readonly');
				}
			};
			typeEl?.addEventListener('change', () => { toggleCnpjForTypeL(); toggleIeTypeRequired(); togglePaymentTermForTypeL(); });
			formset.subscribe?.(['open'], () => {
				setTimeout(toggleCnpjForTypeL, 0);
				setTimeout(toggleIeTypeRequired, 0);
				setTimeout(togglePaymentTermForTypeL, 0);
				setTimeout(() => {
					['billing_address_state', 'delivery_address_state'].forEach(name => {
						const el = document.querySelector(`${sel} #${name}`);
						if (el?.value) el.dispatchEvent(new Event('change', { bubbles: true }));
					});
					if (sameAddrCb?.checked) copyDeliveryToBilling();
				}, 200);
			});
			setTimeout(toggleCnpjForTypeL, 0);
			setTimeout(toggleIeTypeRequired, 0);
			setTimeout(togglePaymentTermForTypeL, 0);
			const sameAddrCb = document.querySelector(`${sel} #same_billing_delivery`);
			const copyDeliveryToBilling = () => {
				if (!sameAddrCb?.checked) return;
				['street', 'number', 'complement', 'district', 'state', 'city_id', 'zipcode'].forEach(f => {
					const src = document.querySelector(`${sel} #delivery_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
					const dst = document.querySelector(`${sel} #billing_address_${f === 'state' ? 'state' : f === 'city_id' ? 'city_id' : f}`);
					if (src && dst) { dst.value = src.value; dst.dispatchEvent(new Event('change', { bubbles: true })); }
				});
			};
			sameAddrCb?.addEventListener('change', copyDeliveryToBilling);
			['street', 'number', 'complement', 'district', 'state', 'city_id', 'zipcode'].forEach(suffix => {
				const f = suffix === 'state' ? 'state' : suffix === 'city_id' ? 'city_id' : suffix;
				document.querySelector(`${sel} #delivery_address_${f}`)?.addEventListener('blur', copyDeliveryToBilling);
			});
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#type' }, types: [types.opt_person_type(), types.datalist()] },
		{ properties: { selector: '#nick' }, types: [types.name()] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#cpf' }, types: [types.cpf()] },
		{ properties: { selector: '#cnpj' }, types: [types.cnpjOrGsnetCode('#customer')] },
		{ properties: { selector: '#ie' }, types: [types.ie()] },
		{ properties: { selector: '#ie_type' }, types: [types.opt_ie_type(), types.datalist()] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#email' }, types: [types.email()] },
		{ properties: { selector: '#billing_address_id' }, types: [] },
		{ properties: { selector: '#billing_address_street' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_number' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_complement' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_district' }, types: [types.name()] },
		{ properties: { selector: '#billing_address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#billing_address_city_id' }, types: [types.pubsub(), types.name(), types.observer('billing_address_state'), types.obs_load_cities(), types.obs_filter_cities('billing_address_state')] },
		{ properties: { selector: '#billing_address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#delivery_address_id' }, types: [] },
		{ properties: { selector: '#delivery_address_street' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_number' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_complement' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_district' }, types: [types.name()] },
		{ properties: { selector: '#delivery_address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#delivery_address_city_id' }, types: [types.pubsub(), types.name(), types.observer('delivery_address_state'), types.obs_load_cities(), types.obs_filter_cities('delivery_address_state')] },
		{ properties: { selector: '#delivery_address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#delivery_term' }, types: [types.number(0)] },
		{ properties: { selector: '#payment_term_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('payment_terms')] },
		{ properties: { selector: '#price_list_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('price_lists')] },
		{ properties: { selector: '#is_end_consumer' }, types: [types.checkbox()] },
	]

};

